import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
    // console.log = function () {};
    enableProdMode();

    // Override all console methods
    const noop = (): any => undefined;
    const methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp',
        'trace', 'warn'
    ];

    methods.forEach((method) => {
        (window.console as any)[method] = noop;
    });
}
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
